export default {
    "scalars": [
        11,
        21,
        31,
        36,
        46,
        63,
        73,
        74,
        76,
        84,
        93,
        102,
        110,
        117,
        124,
        132,
        141,
        149,
        160,
        163,
        171,
        182,
        186,
        197,
        207,
        223,
        226,
        234,
        245,
        257,
        258,
        259,
        260
    ],
    "types": {
        "AssetTypes": {
            "assets": [
                14,
                {
                    "distinctOn": [
                        21,
                        "[AssetsSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        20,
                        "[AssetsOrderBy!]"
                    ],
                    "where": [
                        17
                    ]
                }
            ],
            "company": [
                33
            ],
            "name": [
                226
            ],
            "__typename": [
                226
            ]
        },
        "AssetTypesAggregate": {
            "aggregate": [
                3
            ],
            "nodes": [
                0
            ],
            "__typename": [
                226
            ]
        },
        "AssetTypesAggregateBoolExp": {
            "count": [
                256
            ],
            "__typename": [
                226
            ]
        },
        "AssetTypesAggregateFields": {
            "count": [
                163,
                {
                    "columns": [
                        11,
                        "[AssetTypesSelectColumn!]"
                    ],
                    "distinct": [
                        31
                    ]
                }
            ],
            "max": [
                6
            ],
            "min": [
                8
            ],
            "__typename": [
                226
            ]
        },
        "AssetTypesAggregateOrderBy": {
            "count": [
                186
            ],
            "max": [
                7
            ],
            "min": [
                9
            ],
            "__typename": [
                226
            ]
        },
        "AssetTypesBoolExp": {
            "_and": [
                5
            ],
            "_not": [
                5
            ],
            "_or": [
                5
            ],
            "assets": [
                17
            ],
            "company": [
                34
            ],
            "name": [
                227
            ],
            "__typename": [
                226
            ]
        },
        "AssetTypesMaxFields": {
            "name": [
                226
            ],
            "__typename": [
                226
            ]
        },
        "AssetTypesMaxOrderBy": {
            "name": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "AssetTypesMinFields": {
            "name": [
                226
            ],
            "__typename": [
                226
            ]
        },
        "AssetTypesMinOrderBy": {
            "name": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "AssetTypesOrderBy": {
            "assetsAggregate": [
                15
            ],
            "company": [
                35
            ],
            "name": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "AssetTypesSelectColumn": {},
        "AssetTypesStreamCursorInput": {
            "initialValue": [
                13
            ],
            "ordering": [
                73
            ],
            "__typename": [
                226
            ]
        },
        "AssetTypesStreamCursorValueInput": {
            "name": [
                226
            ],
            "__typename": [
                226
            ]
        },
        "Assets": {
            "barCode": [
                226
            ],
            "company": [
                33
            ],
            "customFields": [
                257,
                {
                    "path": [
                        226
                    ]
                }
            ],
            "location": [
                176
            ],
            "manufacturer": [
                226
            ],
            "model": [
                226
            ],
            "name": [
                226
            ],
            "photo": [
                238
            ],
            "photoId": [
                260
            ],
            "pin": [
                226
            ],
            "procedures": [
                200,
                {
                    "distinctOn": [
                        207,
                        "[ProceduresSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        206,
                        "[ProceduresOrderBy!]"
                    ],
                    "where": [
                        203
                    ]
                }
            ],
            "ratedAmperage": [
                258
            ],
            "serial": [
                226
            ],
            "type": [
                0
            ],
            "voltage": [
                258
            ],
            "__typename": [
                226
            ]
        },
        "AssetsAggregateOrderBy": {
            "avg": [
                16
            ],
            "count": [
                186
            ],
            "max": [
                18
            ],
            "min": [
                19
            ],
            "stddev": [
                22
            ],
            "stddevPop": [
                23
            ],
            "stddevSamp": [
                24
            ],
            "sum": [
                27
            ],
            "varPop": [
                28
            ],
            "varSamp": [
                29
            ],
            "variance": [
                30
            ],
            "__typename": [
                226
            ]
        },
        "AssetsAvgOrderBy": {
            "ratedAmperage": [
                186
            ],
            "voltage": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "AssetsBoolExp": {
            "_and": [
                17
            ],
            "_not": [
                17
            ],
            "_or": [
                17
            ],
            "barCode": [
                227
            ],
            "company": [
                34
            ],
            "customFields": [
                175
            ],
            "location": [
                178
            ],
            "manufacturer": [
                227
            ],
            "model": [
                227
            ],
            "name": [
                227
            ],
            "photo": [
                241
            ],
            "photoId": [
                255
            ],
            "pin": [
                227
            ],
            "procedures": [
                203
            ],
            "ratedAmperage": [
                185
            ],
            "serial": [
                227
            ],
            "type": [
                5
            ],
            "voltage": [
                185
            ],
            "__typename": [
                226
            ]
        },
        "AssetsMaxOrderBy": {
            "barCode": [
                186
            ],
            "manufacturer": [
                186
            ],
            "model": [
                186
            ],
            "name": [
                186
            ],
            "photoId": [
                186
            ],
            "pin": [
                186
            ],
            "ratedAmperage": [
                186
            ],
            "serial": [
                186
            ],
            "voltage": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "AssetsMinOrderBy": {
            "barCode": [
                186
            ],
            "manufacturer": [
                186
            ],
            "model": [
                186
            ],
            "name": [
                186
            ],
            "photoId": [
                186
            ],
            "pin": [
                186
            ],
            "ratedAmperage": [
                186
            ],
            "serial": [
                186
            ],
            "voltage": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "AssetsOrderBy": {
            "barCode": [
                186
            ],
            "company": [
                35
            ],
            "customFields": [
                186
            ],
            "location": [
                181
            ],
            "manufacturer": [
                186
            ],
            "model": [
                186
            ],
            "name": [
                186
            ],
            "photo": [
                244
            ],
            "photoId": [
                186
            ],
            "pin": [
                186
            ],
            "proceduresAggregate": [
                201
            ],
            "ratedAmperage": [
                186
            ],
            "serial": [
                186
            ],
            "type": [
                10
            ],
            "voltage": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "AssetsSelectColumn": {},
        "AssetsStddevOrderBy": {
            "ratedAmperage": [
                186
            ],
            "voltage": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "AssetsStddevPopOrderBy": {
            "ratedAmperage": [
                186
            ],
            "voltage": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "AssetsStddevSampOrderBy": {
            "ratedAmperage": [
                186
            ],
            "voltage": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "AssetsStreamCursorInput": {
            "initialValue": [
                26
            ],
            "ordering": [
                73
            ],
            "__typename": [
                226
            ]
        },
        "AssetsStreamCursorValueInput": {
            "barCode": [
                226
            ],
            "customFields": [
                257
            ],
            "manufacturer": [
                226
            ],
            "model": [
                226
            ],
            "name": [
                226
            ],
            "photoId": [
                260
            ],
            "pin": [
                226
            ],
            "ratedAmperage": [
                258
            ],
            "serial": [
                226
            ],
            "voltage": [
                258
            ],
            "__typename": [
                226
            ]
        },
        "AssetsSumOrderBy": {
            "ratedAmperage": [
                186
            ],
            "voltage": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "AssetsVarPopOrderBy": {
            "ratedAmperage": [
                186
            ],
            "voltage": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "AssetsVarSampOrderBy": {
            "ratedAmperage": [
                186
            ],
            "voltage": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "AssetsVarianceOrderBy": {
            "ratedAmperage": [
                186
            ],
            "voltage": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "Boolean": {},
        "BooleanComparisonExp": {
            "_eq": [
                31
            ],
            "_gt": [
                31
            ],
            "_gte": [
                31
            ],
            "_in": [
                31
            ],
            "_isNull": [
                31
            ],
            "_lt": [
                31
            ],
            "_lte": [
                31
            ],
            "_neq": [
                31
            ],
            "_nin": [
                31
            ],
            "__typename": [
                226
            ]
        },
        "Companies": {
            "assetTypes": [
                0,
                {
                    "distinctOn": [
                        11,
                        "[AssetTypesSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        10,
                        "[AssetTypesOrderBy!]"
                    ],
                    "where": [
                        5
                    ]
                }
            ],
            "assetTypesAggregate": [
                1,
                {
                    "distinctOn": [
                        11,
                        "[AssetTypesSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        10,
                        "[AssetTypesOrderBy!]"
                    ],
                    "where": [
                        5
                    ]
                }
            ],
            "assets": [
                14,
                {
                    "distinctOn": [
                        21,
                        "[AssetsSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        20,
                        "[AssetsOrderBy!]"
                    ],
                    "where": [
                        17
                    ]
                }
            ],
            "controlPoints": [
                56,
                {
                    "distinctOn": [
                        63,
                        "[ControlPointsSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        62,
                        "[ControlPointsOrderBy!]"
                    ],
                    "where": [
                        59
                    ]
                }
            ],
            "customFields": [
                78,
                {
                    "distinctOn": [
                        84,
                        "[CustomFieldsSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        83,
                        "[CustomFieldsOrderBy!]"
                    ],
                    "where": [
                        80
                    ]
                }
            ],
            "energyMeasures": [
                87,
                {
                    "distinctOn": [
                        93,
                        "[EnergyMeasuresSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        92,
                        "[EnergyMeasuresOrderBy!]"
                    ],
                    "where": [
                        89
                    ]
                }
            ],
            "energySources": [
                96,
                {
                    "distinctOn": [
                        102,
                        "[EnergySourcesSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        101,
                        "[EnergySourcesOrderBy!]"
                    ],
                    "where": [
                        98
                    ]
                }
            ],
            "files": [
                238,
                {
                    "distinctOn": [
                        245,
                        "[UploadsSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        244,
                        "[UploadsOrderBy!]"
                    ],
                    "where": [
                        241
                    ]
                }
            ],
            "id": [
                163
            ],
            "isolationDevices": [
                165,
                {
                    "distinctOn": [
                        171,
                        "[IsolationDevicesSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        170,
                        "[IsolationDevicesOrderBy!]"
                    ],
                    "where": [
                        167
                    ]
                }
            ],
            "locations": [
                176,
                {
                    "distinctOn": [
                        182,
                        "[LocationsSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        181,
                        "[LocationsOrderBy!]"
                    ],
                    "where": [
                        178
                    ]
                }
            ],
            "procedureTypes": [
                191,
                {
                    "distinctOn": [
                        197,
                        "[ProcedureTypesSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        196,
                        "[ProcedureTypesOrderBy!]"
                    ],
                    "where": [
                        193
                    ]
                }
            ],
            "procedures": [
                200,
                {
                    "distinctOn": [
                        207,
                        "[ProceduresSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        206,
                        "[ProceduresOrderBy!]"
                    ],
                    "where": [
                        203
                    ]
                }
            ],
            "settings": [
                39
            ],
            "statuses": [
                217,
                {
                    "distinctOn": [
                        223,
                        "[StatusesSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        222,
                        "[StatusesOrderBy!]"
                    ],
                    "where": [
                        219
                    ]
                }
            ],
            "templates": [
                228,
                {
                    "distinctOn": [
                        234,
                        "[TemplatesSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        233,
                        "[TemplatesOrderBy!]"
                    ],
                    "where": [
                        230
                    ]
                }
            ],
            "__typename": [
                226
            ]
        },
        "CompaniesBoolExp": {
            "_and": [
                34
            ],
            "_not": [
                34
            ],
            "_or": [
                34
            ],
            "assetTypes": [
                5
            ],
            "assetTypesAggregate": [
                2
            ],
            "assets": [
                17
            ],
            "controlPoints": [
                59
            ],
            "customFields": [
                80
            ],
            "energyMeasures": [
                89
            ],
            "energySources": [
                98
            ],
            "files": [
                241
            ],
            "id": [
                164
            ],
            "isolationDevices": [
                167
            ],
            "locations": [
                178
            ],
            "procedureTypes": [
                193
            ],
            "procedures": [
                203
            ],
            "settings": [
                42
            ],
            "statuses": [
                219
            ],
            "templates": [
                230
            ],
            "__typename": [
                226
            ]
        },
        "CompaniesOrderBy": {
            "assetTypesAggregate": [
                4
            ],
            "assetsAggregate": [
                15
            ],
            "controlPointsAggregate": [
                57
            ],
            "customFieldsAggregate": [
                79
            ],
            "energyMeasuresAggregate": [
                88
            ],
            "energySourcesAggregate": [
                97
            ],
            "filesAggregate": [
                239
            ],
            "id": [
                186
            ],
            "isolationDevicesAggregate": [
                166
            ],
            "locationsAggregate": [
                177
            ],
            "procedureTypesAggregate": [
                192
            ],
            "proceduresAggregate": [
                201
            ],
            "settings": [
                45
            ],
            "statusesAggregate": [
                218
            ],
            "templatesAggregate": [
                229
            ],
            "__typename": [
                226
            ]
        },
        "CompaniesSelectColumn": {},
        "CompaniesStreamCursorInput": {
            "initialValue": [
                38
            ],
            "ordering": [
                73
            ],
            "__typename": [
                226
            ]
        },
        "CompaniesStreamCursorValueInput": {
            "id": [
                163
            ],
            "__typename": [
                226
            ]
        },
        "CompanySettings": {
            "company": [
                33
            ],
            "companyId": [
                163
            ],
            "defaultStatus": [
                217
            ],
            "defaultTemplate": [
                228
            ],
            "__typename": [
                226
            ]
        },
        "CompanySettingsAggregateOrderBy": {
            "avg": [
                41
            ],
            "count": [
                186
            ],
            "max": [
                43
            ],
            "min": [
                44
            ],
            "stddev": [
                47
            ],
            "stddevPop": [
                48
            ],
            "stddevSamp": [
                49
            ],
            "sum": [
                52
            ],
            "varPop": [
                53
            ],
            "varSamp": [
                54
            ],
            "variance": [
                55
            ],
            "__typename": [
                226
            ]
        },
        "CompanySettingsAvgOrderBy": {
            "companyId": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "CompanySettingsBoolExp": {
            "_and": [
                42
            ],
            "_not": [
                42
            ],
            "_or": [
                42
            ],
            "company": [
                34
            ],
            "companyId": [
                164
            ],
            "defaultStatus": [
                219
            ],
            "defaultTemplate": [
                230
            ],
            "__typename": [
                226
            ]
        },
        "CompanySettingsMaxOrderBy": {
            "companyId": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "CompanySettingsMinOrderBy": {
            "companyId": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "CompanySettingsOrderBy": {
            "company": [
                35
            ],
            "companyId": [
                186
            ],
            "defaultStatus": [
                222
            ],
            "defaultTemplate": [
                233
            ],
            "__typename": [
                226
            ]
        },
        "CompanySettingsSelectColumn": {},
        "CompanySettingsStddevOrderBy": {
            "companyId": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "CompanySettingsStddevPopOrderBy": {
            "companyId": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "CompanySettingsStddevSampOrderBy": {
            "companyId": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "CompanySettingsStreamCursorInput": {
            "initialValue": [
                51
            ],
            "ordering": [
                73
            ],
            "__typename": [
                226
            ]
        },
        "CompanySettingsStreamCursorValueInput": {
            "companyId": [
                163
            ],
            "__typename": [
                226
            ]
        },
        "CompanySettingsSumOrderBy": {
            "companyId": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "CompanySettingsVarPopOrderBy": {
            "companyId": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "CompanySettingsVarSampOrderBy": {
            "companyId": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "CompanySettingsVarianceOrderBy": {
            "companyId": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ControlPoints": {
            "barCode": [
                226
            ],
            "company": [
                33
            ],
            "companyId": [
                163
            ],
            "customFields": [
                257,
                {
                    "path": [
                        226
                    ]
                }
            ],
            "energyMagnitude": [
                163
            ],
            "energyMeasure": [
                87
            ],
            "energySource": [
                96
            ],
            "id": [
                260
            ],
            "isolationDevice": [
                165
            ],
            "isolationLocation": [
                226
            ],
            "methodOverride": [
                226
            ],
            "number": [
                226
            ],
            "photo": [
                238
            ],
            "photoId": [
                260
            ],
            "procedure": [
                200
            ],
            "step": [
                163
            ],
            "updatedOn": [
                259
            ],
            "verificationOverride": [
                226
            ],
            "__typename": [
                226
            ]
        },
        "ControlPointsAggregateOrderBy": {
            "avg": [
                58
            ],
            "count": [
                186
            ],
            "max": [
                60
            ],
            "min": [
                61
            ],
            "stddev": [
                64
            ],
            "stddevPop": [
                65
            ],
            "stddevSamp": [
                66
            ],
            "sum": [
                69
            ],
            "varPop": [
                70
            ],
            "varSamp": [
                71
            ],
            "variance": [
                72
            ],
            "__typename": [
                226
            ]
        },
        "ControlPointsAvgOrderBy": {
            "companyId": [
                186
            ],
            "energyMagnitude": [
                186
            ],
            "step": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ControlPointsBoolExp": {
            "_and": [
                59
            ],
            "_not": [
                59
            ],
            "_or": [
                59
            ],
            "barCode": [
                227
            ],
            "company": [
                34
            ],
            "companyId": [
                164
            ],
            "customFields": [
                175
            ],
            "energyMagnitude": [
                164
            ],
            "energyMeasure": [
                89
            ],
            "energySource": [
                98
            ],
            "id": [
                255
            ],
            "isolationDevice": [
                167
            ],
            "isolationLocation": [
                227
            ],
            "methodOverride": [
                227
            ],
            "number": [
                227
            ],
            "photo": [
                241
            ],
            "photoId": [
                255
            ],
            "procedure": [
                203
            ],
            "step": [
                164
            ],
            "updatedOn": [
                237
            ],
            "verificationOverride": [
                227
            ],
            "__typename": [
                226
            ]
        },
        "ControlPointsMaxOrderBy": {
            "barCode": [
                186
            ],
            "companyId": [
                186
            ],
            "energyMagnitude": [
                186
            ],
            "id": [
                186
            ],
            "isolationLocation": [
                186
            ],
            "methodOverride": [
                186
            ],
            "number": [
                186
            ],
            "photoId": [
                186
            ],
            "step": [
                186
            ],
            "updatedOn": [
                186
            ],
            "verificationOverride": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ControlPointsMinOrderBy": {
            "barCode": [
                186
            ],
            "companyId": [
                186
            ],
            "energyMagnitude": [
                186
            ],
            "id": [
                186
            ],
            "isolationLocation": [
                186
            ],
            "methodOverride": [
                186
            ],
            "number": [
                186
            ],
            "photoId": [
                186
            ],
            "step": [
                186
            ],
            "updatedOn": [
                186
            ],
            "verificationOverride": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ControlPointsOrderBy": {
            "barCode": [
                186
            ],
            "company": [
                35
            ],
            "companyId": [
                186
            ],
            "customFields": [
                186
            ],
            "energyMagnitude": [
                186
            ],
            "energyMeasure": [
                92
            ],
            "energySource": [
                101
            ],
            "id": [
                186
            ],
            "isolationDevice": [
                170
            ],
            "isolationLocation": [
                186
            ],
            "methodOverride": [
                186
            ],
            "number": [
                186
            ],
            "photo": [
                244
            ],
            "photoId": [
                186
            ],
            "procedure": [
                206
            ],
            "step": [
                186
            ],
            "updatedOn": [
                186
            ],
            "verificationOverride": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ControlPointsSelectColumn": {},
        "ControlPointsStddevOrderBy": {
            "companyId": [
                186
            ],
            "energyMagnitude": [
                186
            ],
            "step": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ControlPointsStddevPopOrderBy": {
            "companyId": [
                186
            ],
            "energyMagnitude": [
                186
            ],
            "step": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ControlPointsStddevSampOrderBy": {
            "companyId": [
                186
            ],
            "energyMagnitude": [
                186
            ],
            "step": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ControlPointsStreamCursorInput": {
            "initialValue": [
                68
            ],
            "ordering": [
                73
            ],
            "__typename": [
                226
            ]
        },
        "ControlPointsStreamCursorValueInput": {
            "barCode": [
                226
            ],
            "companyId": [
                163
            ],
            "customFields": [
                257
            ],
            "energyMagnitude": [
                163
            ],
            "id": [
                260
            ],
            "isolationLocation": [
                226
            ],
            "methodOverride": [
                226
            ],
            "number": [
                226
            ],
            "photoId": [
                260
            ],
            "step": [
                163
            ],
            "updatedOn": [
                259
            ],
            "verificationOverride": [
                226
            ],
            "__typename": [
                226
            ]
        },
        "ControlPointsSumOrderBy": {
            "companyId": [
                186
            ],
            "energyMagnitude": [
                186
            ],
            "step": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ControlPointsVarPopOrderBy": {
            "companyId": [
                186
            ],
            "energyMagnitude": [
                186
            ],
            "step": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ControlPointsVarSampOrderBy": {
            "companyId": [
                186
            ],
            "energyMagnitude": [
                186
            ],
            "step": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ControlPointsVarianceOrderBy": {
            "companyId": [
                186
            ],
            "energyMagnitude": [
                186
            ],
            "step": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "CursorOrdering": {},
        "CustomFieldSubjectsEnum": {},
        "CustomFieldSubjectsEnumComparisonExp": {
            "_eq": [
                74
            ],
            "_in": [
                74
            ],
            "_isNull": [
                31
            ],
            "_neq": [
                74
            ],
            "_nin": [
                74
            ],
            "__typename": [
                226
            ]
        },
        "CustomFieldTypesEnum": {},
        "CustomFieldTypesEnumComparisonExp": {
            "_eq": [
                76
            ],
            "_in": [
                76
            ],
            "_isNull": [
                31
            ],
            "_neq": [
                76
            ],
            "_nin": [
                76
            ],
            "__typename": [
                226
            ]
        },
        "CustomFields": {
            "company": [
                33
            ],
            "id": [
                260
            ],
            "name": [
                226
            ],
            "subject": [
                74
            ],
            "type": [
                76
            ],
            "__typename": [
                226
            ]
        },
        "CustomFieldsAggregateOrderBy": {
            "count": [
                186
            ],
            "max": [
                81
            ],
            "min": [
                82
            ],
            "__typename": [
                226
            ]
        },
        "CustomFieldsBoolExp": {
            "_and": [
                80
            ],
            "_not": [
                80
            ],
            "_or": [
                80
            ],
            "company": [
                34
            ],
            "id": [
                255
            ],
            "name": [
                227
            ],
            "subject": [
                75
            ],
            "type": [
                77
            ],
            "__typename": [
                226
            ]
        },
        "CustomFieldsMaxOrderBy": {
            "id": [
                186
            ],
            "name": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "CustomFieldsMinOrderBy": {
            "id": [
                186
            ],
            "name": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "CustomFieldsOrderBy": {
            "company": [
                35
            ],
            "id": [
                186
            ],
            "name": [
                186
            ],
            "subject": [
                186
            ],
            "type": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "CustomFieldsSelectColumn": {},
        "CustomFieldsStreamCursorInput": {
            "initialValue": [
                86
            ],
            "ordering": [
                73
            ],
            "__typename": [
                226
            ]
        },
        "CustomFieldsStreamCursorValueInput": {
            "id": [
                260
            ],
            "name": [
                226
            ],
            "subject": [
                74
            ],
            "type": [
                76
            ],
            "__typename": [
                226
            ]
        },
        "EnergyMeasures": {
            "company": [
                33
            ],
            "controlPoints": [
                56,
                {
                    "distinctOn": [
                        63,
                        "[ControlPointsSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        62,
                        "[ControlPointsOrderBy!]"
                    ],
                    "where": [
                        59
                    ]
                }
            ],
            "energySource": [
                96
            ],
            "name": [
                226
            ],
            "__typename": [
                226
            ]
        },
        "EnergyMeasuresAggregateOrderBy": {
            "count": [
                186
            ],
            "max": [
                90
            ],
            "min": [
                91
            ],
            "__typename": [
                226
            ]
        },
        "EnergyMeasuresBoolExp": {
            "_and": [
                89
            ],
            "_not": [
                89
            ],
            "_or": [
                89
            ],
            "company": [
                34
            ],
            "controlPoints": [
                59
            ],
            "energySource": [
                98
            ],
            "name": [
                227
            ],
            "__typename": [
                226
            ]
        },
        "EnergyMeasuresMaxOrderBy": {
            "name": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "EnergyMeasuresMinOrderBy": {
            "name": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "EnergyMeasuresOrderBy": {
            "company": [
                35
            ],
            "controlPointsAggregate": [
                57
            ],
            "energySource": [
                101
            ],
            "name": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "EnergyMeasuresSelectColumn": {},
        "EnergyMeasuresStreamCursorInput": {
            "initialValue": [
                95
            ],
            "ordering": [
                73
            ],
            "__typename": [
                226
            ]
        },
        "EnergyMeasuresStreamCursorValueInput": {
            "name": [
                226
            ],
            "__typename": [
                226
            ]
        },
        "EnergySources": {
            "color": [
                226
            ],
            "company": [
                33
            ],
            "controlPoints": [
                56,
                {
                    "distinctOn": [
                        63,
                        "[ControlPointsSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        62,
                        "[ControlPointsOrderBy!]"
                    ],
                    "where": [
                        59
                    ]
                }
            ],
            "energyMeasures": [
                87,
                {
                    "distinctOn": [
                        93,
                        "[EnergyMeasuresSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        92,
                        "[EnergyMeasuresOrderBy!]"
                    ],
                    "where": [
                        89
                    ]
                }
            ],
            "icon": [
                238
            ],
            "iconId": [
                260
            ],
            "isolationDevices": [
                165,
                {
                    "distinctOn": [
                        171,
                        "[IsolationDevicesSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        170,
                        "[IsolationDevicesOrderBy!]"
                    ],
                    "where": [
                        167
                    ]
                }
            ],
            "name": [
                226
            ],
            "prefix": [
                226
            ],
            "__typename": [
                226
            ]
        },
        "EnergySourcesAggregateOrderBy": {
            "count": [
                186
            ],
            "max": [
                99
            ],
            "min": [
                100
            ],
            "__typename": [
                226
            ]
        },
        "EnergySourcesBoolExp": {
            "_and": [
                98
            ],
            "_not": [
                98
            ],
            "_or": [
                98
            ],
            "color": [
                227
            ],
            "company": [
                34
            ],
            "controlPoints": [
                59
            ],
            "energyMeasures": [
                89
            ],
            "icon": [
                241
            ],
            "iconId": [
                255
            ],
            "isolationDevices": [
                167
            ],
            "name": [
                227
            ],
            "prefix": [
                227
            ],
            "__typename": [
                226
            ]
        },
        "EnergySourcesMaxOrderBy": {
            "color": [
                186
            ],
            "iconId": [
                186
            ],
            "name": [
                186
            ],
            "prefix": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "EnergySourcesMinOrderBy": {
            "color": [
                186
            ],
            "iconId": [
                186
            ],
            "name": [
                186
            ],
            "prefix": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "EnergySourcesOrderBy": {
            "color": [
                186
            ],
            "company": [
                35
            ],
            "controlPointsAggregate": [
                57
            ],
            "energyMeasuresAggregate": [
                88
            ],
            "icon": [
                244
            ],
            "iconId": [
                186
            ],
            "isolationDevicesAggregate": [
                166
            ],
            "name": [
                186
            ],
            "prefix": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "EnergySourcesSelectColumn": {},
        "EnergySourcesStreamCursorInput": {
            "initialValue": [
                104
            ],
            "ordering": [
                73
            ],
            "__typename": [
                226
            ]
        },
        "EnergySourcesStreamCursorValueInput": {
            "color": [
                226
            ],
            "iconId": [
                260
            ],
            "name": [
                226
            ],
            "prefix": [
                226
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionActions": {
            "anonymousCompanyName": [
                226
            ],
            "anonymousName": [
                226
            ],
            "company": [
                33
            ],
            "companyId": [
                163
            ],
            "controlPoint": [
                56
            ],
            "createdOn": [
                259
            ],
            "execution": [
                128
            ],
            "id": [
                260
            ],
            "status": [
                31
            ],
            "updatedOn": [
                259
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionActionsAggregateOrderBy": {
            "avg": [
                108
            ],
            "count": [
                186
            ],
            "max": [
                112
            ],
            "min": [
                113
            ],
            "stddev": [
                118
            ],
            "stddevPop": [
                119
            ],
            "stddevSamp": [
                120
            ],
            "sum": [
                123
            ],
            "varPop": [
                125
            ],
            "varSamp": [
                126
            ],
            "variance": [
                127
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionActionsArrRelInsertInput": {
            "data": [
                111
            ],
            "onConflict": [
                115
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionActionsAvgOrderBy": {
            "companyId": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionActionsBoolExp": {
            "_and": [
                109
            ],
            "_not": [
                109
            ],
            "_or": [
                109
            ],
            "anonymousCompanyName": [
                227
            ],
            "anonymousName": [
                227
            ],
            "company": [
                34
            ],
            "companyId": [
                164
            ],
            "controlPoint": [
                59
            ],
            "createdOn": [
                237
            ],
            "execution": [
                131
            ],
            "id": [
                255
            ],
            "status": [
                32
            ],
            "updatedOn": [
                237
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionActionsConstraint": {},
        "ExecutionActionsInsertInput": {
            "anonymousCompanyName": [
                226
            ],
            "anonymousName": [
                226
            ],
            "companyId": [
                163
            ],
            "controlPointId": [
                260
            ],
            "execution": [
                137
            ],
            "executionId": [
                260
            ],
            "status": [
                31
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionActionsMaxOrderBy": {
            "anonymousCompanyName": [
                186
            ],
            "anonymousName": [
                186
            ],
            "companyId": [
                186
            ],
            "createdOn": [
                186
            ],
            "id": [
                186
            ],
            "updatedOn": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionActionsMinOrderBy": {
            "anonymousCompanyName": [
                186
            ],
            "anonymousName": [
                186
            ],
            "companyId": [
                186
            ],
            "createdOn": [
                186
            ],
            "id": [
                186
            ],
            "updatedOn": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionActionsMutationResponse": {
            "affectedRows": [
                163
            ],
            "returning": [
                105
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionActionsOnConflict": {
            "constraint": [
                110
            ],
            "updateColumns": [
                124
            ],
            "where": [
                109
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionActionsOrderBy": {
            "anonymousCompanyName": [
                186
            ],
            "anonymousName": [
                186
            ],
            "company": [
                35
            ],
            "companyId": [
                186
            ],
            "controlPoint": [
                62
            ],
            "createdOn": [
                186
            ],
            "execution": [
                139
            ],
            "id": [
                186
            ],
            "status": [
                186
            ],
            "updatedOn": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionActionsSelectColumn": {},
        "ExecutionActionsStddevOrderBy": {
            "companyId": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionActionsStddevPopOrderBy": {
            "companyId": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionActionsStddevSampOrderBy": {
            "companyId": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionActionsStreamCursorInput": {
            "initialValue": [
                122
            ],
            "ordering": [
                73
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionActionsStreamCursorValueInput": {
            "anonymousCompanyName": [
                226
            ],
            "anonymousName": [
                226
            ],
            "companyId": [
                163
            ],
            "createdOn": [
                259
            ],
            "id": [
                260
            ],
            "status": [
                31
            ],
            "updatedOn": [
                259
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionActionsSumOrderBy": {
            "companyId": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionActionsUpdateColumn": {},
        "ExecutionActionsVarPopOrderBy": {
            "companyId": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionActionsVarSampOrderBy": {
            "companyId": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionActionsVarianceOrderBy": {
            "companyId": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "Executions": {
            "actions": [
                105,
                {
                    "distinctOn": [
                        117,
                        "[ExecutionActionsSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        116,
                        "[ExecutionActionsOrderBy!]"
                    ],
                    "where": [
                        109
                    ]
                }
            ],
            "anonymousCompanyName": [
                226
            ],
            "anonymousName": [
                226
            ],
            "company": [
                33
            ],
            "companyId": [
                163
            ],
            "createdOn": [
                259
            ],
            "id": [
                260
            ],
            "procedure": [
                200
            ],
            "status": [
                31
            ],
            "updatedOn": [
                259
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionsAggregateOrderBy": {
            "avg": [
                130
            ],
            "count": [
                186
            ],
            "max": [
                134
            ],
            "min": [
                135
            ],
            "stddev": [
                143
            ],
            "stddevPop": [
                144
            ],
            "stddevSamp": [
                145
            ],
            "sum": [
                148
            ],
            "varPop": [
                151
            ],
            "varSamp": [
                152
            ],
            "variance": [
                153
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionsAvgOrderBy": {
            "companyId": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionsBoolExp": {
            "_and": [
                131
            ],
            "_not": [
                131
            ],
            "_or": [
                131
            ],
            "actions": [
                109
            ],
            "anonymousCompanyName": [
                227
            ],
            "anonymousName": [
                227
            ],
            "company": [
                34
            ],
            "companyId": [
                164
            ],
            "createdOn": [
                237
            ],
            "id": [
                255
            ],
            "procedure": [
                203
            ],
            "status": [
                32
            ],
            "updatedOn": [
                237
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionsConstraint": {},
        "ExecutionsInsertInput": {
            "actions": [
                107
            ],
            "anonymousCompanyName": [
                226
            ],
            "anonymousName": [
                226
            ],
            "companyId": [
                163
            ],
            "procedureId": [
                260
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionsMaxOrderBy": {
            "anonymousCompanyName": [
                186
            ],
            "anonymousName": [
                186
            ],
            "companyId": [
                186
            ],
            "createdOn": [
                186
            ],
            "id": [
                186
            ],
            "updatedOn": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionsMinOrderBy": {
            "anonymousCompanyName": [
                186
            ],
            "anonymousName": [
                186
            ],
            "companyId": [
                186
            ],
            "createdOn": [
                186
            ],
            "id": [
                186
            ],
            "updatedOn": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionsMutationResponse": {
            "affectedRows": [
                163
            ],
            "returning": [
                128
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionsObjRelInsertInput": {
            "data": [
                133
            ],
            "onConflict": [
                138
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionsOnConflict": {
            "constraint": [
                132
            ],
            "updateColumns": [
                149
            ],
            "where": [
                131
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionsOrderBy": {
            "actionsAggregate": [
                106
            ],
            "anonymousCompanyName": [
                186
            ],
            "anonymousName": [
                186
            ],
            "company": [
                35
            ],
            "companyId": [
                186
            ],
            "createdOn": [
                186
            ],
            "id": [
                186
            ],
            "procedure": [
                206
            ],
            "status": [
                186
            ],
            "updatedOn": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionsPkColumnsInput": {
            "companyId": [
                163
            ],
            "id": [
                260
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionsSelectColumn": {},
        "ExecutionsSetInput": {
            "anonymousCompanyName": [
                226
            ],
            "status": [
                31
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionsStddevOrderBy": {
            "companyId": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionsStddevPopOrderBy": {
            "companyId": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionsStddevSampOrderBy": {
            "companyId": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionsStreamCursorInput": {
            "initialValue": [
                147
            ],
            "ordering": [
                73
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionsStreamCursorValueInput": {
            "anonymousCompanyName": [
                226
            ],
            "anonymousName": [
                226
            ],
            "companyId": [
                163
            ],
            "createdOn": [
                259
            ],
            "id": [
                260
            ],
            "status": [
                31
            ],
            "updatedOn": [
                259
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionsSumOrderBy": {
            "companyId": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionsUpdateColumn": {},
        "ExecutionsUpdates": {
            "_set": [
                142
            ],
            "where": [
                131
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionsVarPopOrderBy": {
            "companyId": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionsVarSampOrderBy": {
            "companyId": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ExecutionsVarianceOrderBy": {
            "companyId": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "Hazards": {
            "color": [
                226
            ],
            "company": [
                33
            ],
            "icon": [
                238
            ],
            "id": [
                260
            ],
            "name": [
                226
            ],
            "procedureHazards": [
                187,
                {
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        190,
                        "[ProcedureHazardsOrderBy!]"
                    ],
                    "where": [
                        189
                    ]
                }
            ],
            "statement": [
                226
            ],
            "__typename": [
                226
            ]
        },
        "HazardsAggregateOrderBy": {
            "count": [
                186
            ],
            "max": [
                157
            ],
            "min": [
                158
            ],
            "__typename": [
                226
            ]
        },
        "HazardsBoolExp": {
            "_and": [
                156
            ],
            "_not": [
                156
            ],
            "_or": [
                156
            ],
            "color": [
                227
            ],
            "company": [
                34
            ],
            "icon": [
                241
            ],
            "id": [
                255
            ],
            "name": [
                227
            ],
            "procedureHazards": [
                189
            ],
            "statement": [
                227
            ],
            "__typename": [
                226
            ]
        },
        "HazardsMaxOrderBy": {
            "color": [
                186
            ],
            "id": [
                186
            ],
            "name": [
                186
            ],
            "statement": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "HazardsMinOrderBy": {
            "color": [
                186
            ],
            "id": [
                186
            ],
            "name": [
                186
            ],
            "statement": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "HazardsOrderBy": {
            "color": [
                186
            ],
            "company": [
                35
            ],
            "icon": [
                244
            ],
            "id": [
                186
            ],
            "name": [
                186
            ],
            "procedureHazardsAggregate": [
                188
            ],
            "statement": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "HazardsSelectColumn": {},
        "HazardsStreamCursorInput": {
            "initialValue": [
                162
            ],
            "ordering": [
                73
            ],
            "__typename": [
                226
            ]
        },
        "HazardsStreamCursorValueInput": {
            "color": [
                226
            ],
            "id": [
                260
            ],
            "name": [
                226
            ],
            "statement": [
                226
            ],
            "__typename": [
                226
            ]
        },
        "Int": {},
        "IntComparisonExp": {
            "_eq": [
                163
            ],
            "_gt": [
                163
            ],
            "_gte": [
                163
            ],
            "_in": [
                163
            ],
            "_isNull": [
                31
            ],
            "_lt": [
                163
            ],
            "_lte": [
                163
            ],
            "_neq": [
                163
            ],
            "_nin": [
                163
            ],
            "__typename": [
                226
            ]
        },
        "IsolationDevices": {
            "company": [
                33
            ],
            "controlPoints": [
                56,
                {
                    "distinctOn": [
                        63,
                        "[ControlPointsSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        62,
                        "[ControlPointsOrderBy!]"
                    ],
                    "where": [
                        59
                    ]
                }
            ],
            "energySource": [
                96
            ],
            "icon": [
                238
            ],
            "iconId": [
                260
            ],
            "methodStatement": [
                226
            ],
            "name": [
                226
            ],
            "verificationStatement": [
                226
            ],
            "video": [
                238
            ],
            "videoId": [
                260
            ],
            "__typename": [
                226
            ]
        },
        "IsolationDevicesAggregateOrderBy": {
            "count": [
                186
            ],
            "max": [
                168
            ],
            "min": [
                169
            ],
            "__typename": [
                226
            ]
        },
        "IsolationDevicesBoolExp": {
            "_and": [
                167
            ],
            "_not": [
                167
            ],
            "_or": [
                167
            ],
            "company": [
                34
            ],
            "controlPoints": [
                59
            ],
            "energySource": [
                98
            ],
            "icon": [
                241
            ],
            "iconId": [
                255
            ],
            "methodStatement": [
                227
            ],
            "name": [
                227
            ],
            "verificationStatement": [
                227
            ],
            "video": [
                241
            ],
            "videoId": [
                255
            ],
            "__typename": [
                226
            ]
        },
        "IsolationDevicesMaxOrderBy": {
            "iconId": [
                186
            ],
            "methodStatement": [
                186
            ],
            "name": [
                186
            ],
            "verificationStatement": [
                186
            ],
            "videoId": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "IsolationDevicesMinOrderBy": {
            "iconId": [
                186
            ],
            "methodStatement": [
                186
            ],
            "name": [
                186
            ],
            "verificationStatement": [
                186
            ],
            "videoId": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "IsolationDevicesOrderBy": {
            "company": [
                35
            ],
            "controlPointsAggregate": [
                57
            ],
            "energySource": [
                101
            ],
            "icon": [
                244
            ],
            "iconId": [
                186
            ],
            "methodStatement": [
                186
            ],
            "name": [
                186
            ],
            "verificationStatement": [
                186
            ],
            "video": [
                244
            ],
            "videoId": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "IsolationDevicesSelectColumn": {},
        "IsolationDevicesStreamCursorInput": {
            "initialValue": [
                173
            ],
            "ordering": [
                73
            ],
            "__typename": [
                226
            ]
        },
        "IsolationDevicesStreamCursorValueInput": {
            "iconId": [
                260
            ],
            "methodStatement": [
                226
            ],
            "name": [
                226
            ],
            "verificationStatement": [
                226
            ],
            "videoId": [
                260
            ],
            "__typename": [
                226
            ]
        },
        "JsonbCastExp": {
            "String": [
                227
            ],
            "__typename": [
                226
            ]
        },
        "JsonbComparisonExp": {
            "_cast": [
                174
            ],
            "_containedIn": [
                257
            ],
            "_contains": [
                257
            ],
            "_eq": [
                257
            ],
            "_gt": [
                257
            ],
            "_gte": [
                257
            ],
            "_hasKey": [
                226
            ],
            "_hasKeysAll": [
                226
            ],
            "_hasKeysAny": [
                226
            ],
            "_in": [
                257
            ],
            "_isNull": [
                31
            ],
            "_jsonbPathExists": [
                226
            ],
            "_jsonbPathMatch": [
                226
            ],
            "_lt": [
                257
            ],
            "_lte": [
                257
            ],
            "_neq": [
                257
            ],
            "_nin": [
                257
            ],
            "__typename": [
                226
            ]
        },
        "Locations": {
            "address": [
                226
            ],
            "assets": [
                14,
                {
                    "distinctOn": [
                        21,
                        "[AssetsSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        20,
                        "[AssetsOrderBy!]"
                    ],
                    "where": [
                        17
                    ]
                }
            ],
            "company": [
                33
            ],
            "customFields": [
                257,
                {
                    "path": [
                        226
                    ]
                }
            ],
            "name": [
                226
            ],
            "__typename": [
                226
            ]
        },
        "LocationsAggregateOrderBy": {
            "count": [
                186
            ],
            "max": [
                179
            ],
            "min": [
                180
            ],
            "__typename": [
                226
            ]
        },
        "LocationsBoolExp": {
            "_and": [
                178
            ],
            "_not": [
                178
            ],
            "_or": [
                178
            ],
            "address": [
                227
            ],
            "assets": [
                17
            ],
            "company": [
                34
            ],
            "customFields": [
                175
            ],
            "name": [
                227
            ],
            "__typename": [
                226
            ]
        },
        "LocationsMaxOrderBy": {
            "address": [
                186
            ],
            "name": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "LocationsMinOrderBy": {
            "address": [
                186
            ],
            "name": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "LocationsOrderBy": {
            "address": [
                186
            ],
            "assetsAggregate": [
                15
            ],
            "company": [
                35
            ],
            "customFields": [
                186
            ],
            "name": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "LocationsSelectColumn": {},
        "LocationsStreamCursorInput": {
            "initialValue": [
                184
            ],
            "ordering": [
                73
            ],
            "__typename": [
                226
            ]
        },
        "LocationsStreamCursorValueInput": {
            "address": [
                226
            ],
            "customFields": [
                257
            ],
            "name": [
                226
            ],
            "__typename": [
                226
            ]
        },
        "NumericComparisonExp": {
            "_eq": [
                258
            ],
            "_gt": [
                258
            ],
            "_gte": [
                258
            ],
            "_in": [
                258
            ],
            "_isNull": [
                31
            ],
            "_lt": [
                258
            ],
            "_lte": [
                258
            ],
            "_neq": [
                258
            ],
            "_nin": [
                258
            ],
            "__typename": [
                226
            ]
        },
        "OrderBy": {},
        "ProcedureHazards": {
            "company": [
                33
            ],
            "hazard": [
                154
            ],
            "procedure": [
                200
            ],
            "__typename": [
                226
            ]
        },
        "ProcedureHazardsAggregateOrderBy": {
            "count": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ProcedureHazardsBoolExp": {
            "_and": [
                189
            ],
            "_not": [
                189
            ],
            "_or": [
                189
            ],
            "company": [
                34
            ],
            "hazard": [
                156
            ],
            "procedure": [
                203
            ],
            "__typename": [
                226
            ]
        },
        "ProcedureHazardsOrderBy": {
            "company": [
                35
            ],
            "hazard": [
                159
            ],
            "procedure": [
                206
            ],
            "__typename": [
                226
            ]
        },
        "ProcedureTypes": {
            "company": [
                33
            ],
            "name": [
                226
            ],
            "procedures": [
                200,
                {
                    "distinctOn": [
                        207,
                        "[ProceduresSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        206,
                        "[ProceduresOrderBy!]"
                    ],
                    "where": [
                        203
                    ]
                }
            ],
            "__typename": [
                226
            ]
        },
        "ProcedureTypesAggregateOrderBy": {
            "count": [
                186
            ],
            "max": [
                194
            ],
            "min": [
                195
            ],
            "__typename": [
                226
            ]
        },
        "ProcedureTypesBoolExp": {
            "_and": [
                193
            ],
            "_not": [
                193
            ],
            "_or": [
                193
            ],
            "company": [
                34
            ],
            "name": [
                227
            ],
            "procedures": [
                203
            ],
            "__typename": [
                226
            ]
        },
        "ProcedureTypesMaxOrderBy": {
            "name": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ProcedureTypesMinOrderBy": {
            "name": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ProcedureTypesOrderBy": {
            "company": [
                35
            ],
            "name": [
                186
            ],
            "proceduresAggregate": [
                201
            ],
            "__typename": [
                226
            ]
        },
        "ProcedureTypesSelectColumn": {},
        "ProcedureTypesStreamCursorInput": {
            "initialValue": [
                199
            ],
            "ordering": [
                73
            ],
            "__typename": [
                226
            ]
        },
        "ProcedureTypesStreamCursorValueInput": {
            "name": [
                226
            ],
            "__typename": [
                226
            ]
        },
        "Procedures": {
            "asset": [
                14
            ],
            "company": [
                33
            ],
            "companyId": [
                163
            ],
            "controlPoints": [
                56,
                {
                    "distinctOn": [
                        63,
                        "[ControlPointsSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        62,
                        "[ControlPointsOrderBy!]"
                    ],
                    "where": [
                        59
                    ]
                }
            ],
            "createdOn": [
                259
            ],
            "customFields": [
                257,
                {
                    "path": [
                        226
                    ]
                }
            ],
            "executions": [
                128,
                {
                    "distinctOn": [
                        141,
                        "[ExecutionsSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        139,
                        "[ExecutionsOrderBy!]"
                    ],
                    "where": [
                        131
                    ]
                }
            ],
            "id": [
                260
            ],
            "procedureHazards": [
                187,
                {
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        190,
                        "[ProcedureHazardsOrderBy!]"
                    ],
                    "where": [
                        189
                    ]
                }
            ],
            "status": [
                217
            ],
            "type": [
                191
            ],
            "updatedOn": [
                259
            ],
            "__typename": [
                226
            ]
        },
        "ProceduresAggregateOrderBy": {
            "avg": [
                202
            ],
            "count": [
                186
            ],
            "max": [
                204
            ],
            "min": [
                205
            ],
            "stddev": [
                208
            ],
            "stddevPop": [
                209
            ],
            "stddevSamp": [
                210
            ],
            "sum": [
                213
            ],
            "varPop": [
                214
            ],
            "varSamp": [
                215
            ],
            "variance": [
                216
            ],
            "__typename": [
                226
            ]
        },
        "ProceduresAvgOrderBy": {
            "companyId": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ProceduresBoolExp": {
            "_and": [
                203
            ],
            "_not": [
                203
            ],
            "_or": [
                203
            ],
            "asset": [
                17
            ],
            "company": [
                34
            ],
            "companyId": [
                164
            ],
            "controlPoints": [
                59
            ],
            "createdOn": [
                237
            ],
            "customFields": [
                175
            ],
            "executions": [
                131
            ],
            "id": [
                255
            ],
            "procedureHazards": [
                189
            ],
            "status": [
                219
            ],
            "type": [
                193
            ],
            "updatedOn": [
                237
            ],
            "__typename": [
                226
            ]
        },
        "ProceduresMaxOrderBy": {
            "companyId": [
                186
            ],
            "createdOn": [
                186
            ],
            "id": [
                186
            ],
            "updatedOn": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ProceduresMinOrderBy": {
            "companyId": [
                186
            ],
            "createdOn": [
                186
            ],
            "id": [
                186
            ],
            "updatedOn": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ProceduresOrderBy": {
            "asset": [
                20
            ],
            "company": [
                35
            ],
            "companyId": [
                186
            ],
            "controlPointsAggregate": [
                57
            ],
            "createdOn": [
                186
            ],
            "customFields": [
                186
            ],
            "executionsAggregate": [
                129
            ],
            "id": [
                186
            ],
            "procedureHazardsAggregate": [
                188
            ],
            "status": [
                222
            ],
            "type": [
                196
            ],
            "updatedOn": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ProceduresSelectColumn": {},
        "ProceduresStddevOrderBy": {
            "companyId": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ProceduresStddevPopOrderBy": {
            "companyId": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ProceduresStddevSampOrderBy": {
            "companyId": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ProceduresStreamCursorInput": {
            "initialValue": [
                212
            ],
            "ordering": [
                73
            ],
            "__typename": [
                226
            ]
        },
        "ProceduresStreamCursorValueInput": {
            "companyId": [
                163
            ],
            "createdOn": [
                259
            ],
            "customFields": [
                257
            ],
            "id": [
                260
            ],
            "updatedOn": [
                259
            ],
            "__typename": [
                226
            ]
        },
        "ProceduresSumOrderBy": {
            "companyId": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ProceduresVarPopOrderBy": {
            "companyId": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ProceduresVarSampOrderBy": {
            "companyId": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "ProceduresVarianceOrderBy": {
            "companyId": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "Statuses": {
            "color": [
                226
            ],
            "company": [
                33
            ],
            "default_of": [
                39,
                {
                    "distinctOn": [
                        46,
                        "[CompanySettingsSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        45,
                        "[CompanySettingsOrderBy!]"
                    ],
                    "where": [
                        42
                    ]
                }
            ],
            "name": [
                226
            ],
            "procedures": [
                200,
                {
                    "distinctOn": [
                        207,
                        "[ProceduresSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        206,
                        "[ProceduresOrderBy!]"
                    ],
                    "where": [
                        203
                    ]
                }
            ],
            "__typename": [
                226
            ]
        },
        "StatusesAggregateOrderBy": {
            "count": [
                186
            ],
            "max": [
                220
            ],
            "min": [
                221
            ],
            "__typename": [
                226
            ]
        },
        "StatusesBoolExp": {
            "_and": [
                219
            ],
            "_not": [
                219
            ],
            "_or": [
                219
            ],
            "color": [
                227
            ],
            "company": [
                34
            ],
            "default_of": [
                42
            ],
            "name": [
                227
            ],
            "procedures": [
                203
            ],
            "__typename": [
                226
            ]
        },
        "StatusesMaxOrderBy": {
            "color": [
                186
            ],
            "name": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "StatusesMinOrderBy": {
            "color": [
                186
            ],
            "name": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "StatusesOrderBy": {
            "color": [
                186
            ],
            "company": [
                35
            ],
            "default_ofAggregate": [
                40
            ],
            "name": [
                186
            ],
            "proceduresAggregate": [
                201
            ],
            "__typename": [
                226
            ]
        },
        "StatusesSelectColumn": {},
        "StatusesStreamCursorInput": {
            "initialValue": [
                225
            ],
            "ordering": [
                73
            ],
            "__typename": [
                226
            ]
        },
        "StatusesStreamCursorValueInput": {
            "color": [
                226
            ],
            "name": [
                226
            ],
            "__typename": [
                226
            ]
        },
        "String": {},
        "StringComparisonExp": {
            "_eq": [
                226
            ],
            "_gt": [
                226
            ],
            "_gte": [
                226
            ],
            "_ilike": [
                226
            ],
            "_in": [
                226
            ],
            "_iregex": [
                226
            ],
            "_isNull": [
                31
            ],
            "_like": [
                226
            ],
            "_lt": [
                226
            ],
            "_lte": [
                226
            ],
            "_neq": [
                226
            ],
            "_nilike": [
                226
            ],
            "_nin": [
                226
            ],
            "_niregex": [
                226
            ],
            "_nlike": [
                226
            ],
            "_nregex": [
                226
            ],
            "_nsimilar": [
                226
            ],
            "_regex": [
                226
            ],
            "_similar": [
                226
            ],
            "__typename": [
                226
            ]
        },
        "Templates": {
            "company": [
                33
            ],
            "css": [
                226
            ],
            "default_of": [
                39,
                {
                    "distinctOn": [
                        46,
                        "[CompanySettingsSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        45,
                        "[CompanySettingsOrderBy!]"
                    ],
                    "where": [
                        42
                    ]
                }
            ],
            "html": [
                226
            ],
            "__typename": [
                226
            ]
        },
        "TemplatesAggregateOrderBy": {
            "count": [
                186
            ],
            "max": [
                231
            ],
            "min": [
                232
            ],
            "__typename": [
                226
            ]
        },
        "TemplatesBoolExp": {
            "_and": [
                230
            ],
            "_not": [
                230
            ],
            "_or": [
                230
            ],
            "company": [
                34
            ],
            "css": [
                227
            ],
            "default_of": [
                42
            ],
            "html": [
                227
            ],
            "__typename": [
                226
            ]
        },
        "TemplatesMaxOrderBy": {
            "css": [
                186
            ],
            "html": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "TemplatesMinOrderBy": {
            "css": [
                186
            ],
            "html": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "TemplatesOrderBy": {
            "company": [
                35
            ],
            "css": [
                186
            ],
            "default_ofAggregate": [
                40
            ],
            "html": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "TemplatesSelectColumn": {},
        "TemplatesStreamCursorInput": {
            "initialValue": [
                236
            ],
            "ordering": [
                73
            ],
            "__typename": [
                226
            ]
        },
        "TemplatesStreamCursorValueInput": {
            "css": [
                226
            ],
            "html": [
                226
            ],
            "__typename": [
                226
            ]
        },
        "TimestamptzComparisonExp": {
            "_eq": [
                259
            ],
            "_gt": [
                259
            ],
            "_gte": [
                259
            ],
            "_in": [
                259
            ],
            "_isNull": [
                31
            ],
            "_lt": [
                259
            ],
            "_lte": [
                259
            ],
            "_neq": [
                259
            ],
            "_nin": [
                259
            ],
            "__typename": [
                226
            ]
        },
        "Uploads": {
            "assets": [
                14,
                {
                    "distinctOn": [
                        21,
                        "[AssetsSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        20,
                        "[AssetsOrderBy!]"
                    ],
                    "where": [
                        17
                    ]
                }
            ],
            "company": [
                33
            ],
            "control_points": [
                56,
                {
                    "distinctOn": [
                        63,
                        "[ControlPointsSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        62,
                        "[ControlPointsOrderBy!]"
                    ],
                    "where": [
                        59
                    ]
                }
            ],
            "energy_sources": [
                96,
                {
                    "distinctOn": [
                        102,
                        "[EnergySourcesSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        101,
                        "[EnergySourcesOrderBy!]"
                    ],
                    "where": [
                        98
                    ]
                }
            ],
            "hazards": [
                154,
                {
                    "distinctOn": [
                        160,
                        "[HazardsSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        159,
                        "[HazardsOrderBy!]"
                    ],
                    "where": [
                        156
                    ]
                }
            ],
            "height": [
                163
            ],
            "id": [
                260
            ],
            "isolationDevicesByCompanyIdVideoId": [
                165,
                {
                    "distinctOn": [
                        171,
                        "[IsolationDevicesSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        170,
                        "[IsolationDevicesOrderBy!]"
                    ],
                    "where": [
                        167
                    ]
                }
            ],
            "isolation_devices": [
                165,
                {
                    "distinctOn": [
                        171,
                        "[IsolationDevicesSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        170,
                        "[IsolationDevicesOrderBy!]"
                    ],
                    "where": [
                        167
                    ]
                }
            ],
            "name": [
                226
            ],
            "present": [
                31
            ],
            "resized": [
                31
            ],
            "type": [
                226
            ],
            "width": [
                163
            ],
            "__typename": [
                226
            ]
        },
        "UploadsAggregateOrderBy": {
            "avg": [
                240
            ],
            "count": [
                186
            ],
            "max": [
                242
            ],
            "min": [
                243
            ],
            "stddev": [
                246
            ],
            "stddevPop": [
                247
            ],
            "stddevSamp": [
                248
            ],
            "sum": [
                251
            ],
            "varPop": [
                252
            ],
            "varSamp": [
                253
            ],
            "variance": [
                254
            ],
            "__typename": [
                226
            ]
        },
        "UploadsAvgOrderBy": {
            "height": [
                186
            ],
            "width": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "UploadsBoolExp": {
            "_and": [
                241
            ],
            "_not": [
                241
            ],
            "_or": [
                241
            ],
            "assets": [
                17
            ],
            "company": [
                34
            ],
            "control_points": [
                59
            ],
            "energy_sources": [
                98
            ],
            "hazards": [
                156
            ],
            "height": [
                164
            ],
            "id": [
                255
            ],
            "isolationDevicesByCompanyIdVideoId": [
                167
            ],
            "isolation_devices": [
                167
            ],
            "name": [
                227
            ],
            "present": [
                32
            ],
            "resized": [
                32
            ],
            "type": [
                227
            ],
            "width": [
                164
            ],
            "__typename": [
                226
            ]
        },
        "UploadsMaxOrderBy": {
            "height": [
                186
            ],
            "id": [
                186
            ],
            "name": [
                186
            ],
            "type": [
                186
            ],
            "width": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "UploadsMinOrderBy": {
            "height": [
                186
            ],
            "id": [
                186
            ],
            "name": [
                186
            ],
            "type": [
                186
            ],
            "width": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "UploadsOrderBy": {
            "assetsAggregate": [
                15
            ],
            "company": [
                35
            ],
            "control_pointsAggregate": [
                57
            ],
            "energy_sourcesAggregate": [
                97
            ],
            "hazardsAggregate": [
                155
            ],
            "height": [
                186
            ],
            "id": [
                186
            ],
            "isolationDevicesByCompanyIdVideoIdAggregate": [
                166
            ],
            "isolation_devicesAggregate": [
                166
            ],
            "name": [
                186
            ],
            "present": [
                186
            ],
            "resized": [
                186
            ],
            "type": [
                186
            ],
            "width": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "UploadsSelectColumn": {},
        "UploadsStddevOrderBy": {
            "height": [
                186
            ],
            "width": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "UploadsStddevPopOrderBy": {
            "height": [
                186
            ],
            "width": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "UploadsStddevSampOrderBy": {
            "height": [
                186
            ],
            "width": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "UploadsStreamCursorInput": {
            "initialValue": [
                250
            ],
            "ordering": [
                73
            ],
            "__typename": [
                226
            ]
        },
        "UploadsStreamCursorValueInput": {
            "height": [
                163
            ],
            "id": [
                260
            ],
            "name": [
                226
            ],
            "present": [
                31
            ],
            "resized": [
                31
            ],
            "type": [
                226
            ],
            "width": [
                163
            ],
            "__typename": [
                226
            ]
        },
        "UploadsSumOrderBy": {
            "height": [
                186
            ],
            "width": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "UploadsVarPopOrderBy": {
            "height": [
                186
            ],
            "width": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "UploadsVarSampOrderBy": {
            "height": [
                186
            ],
            "width": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "UploadsVarianceOrderBy": {
            "height": [
                186
            ],
            "width": [
                186
            ],
            "__typename": [
                226
            ]
        },
        "UuidComparisonExp": {
            "_eq": [
                260
            ],
            "_gt": [
                260
            ],
            "_gte": [
                260
            ],
            "_in": [
                260
            ],
            "_isNull": [
                31
            ],
            "_lt": [
                260
            ],
            "_lte": [
                260
            ],
            "_neq": [
                260
            ],
            "_nin": [
                260
            ],
            "__typename": [
                226
            ]
        },
        "assetTypesAggregateBoolExpCount": {
            "arguments": [
                11
            ],
            "distinct": [
                31
            ],
            "filter": [
                5
            ],
            "predicate": [
                164
            ],
            "__typename": [
                226
            ]
        },
        "jsonb": {},
        "numeric": {},
        "timestamptz": {},
        "uuid": {},
        "Query": {
            "assetTypes": [
                0,
                {
                    "distinctOn": [
                        11,
                        "[AssetTypesSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        10,
                        "[AssetTypesOrderBy!]"
                    ],
                    "where": [
                        5
                    ]
                }
            ],
            "assetTypesAggregate": [
                1,
                {
                    "distinctOn": [
                        11,
                        "[AssetTypesSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        10,
                        "[AssetTypesOrderBy!]"
                    ],
                    "where": [
                        5
                    ]
                }
            ],
            "assets": [
                14,
                {
                    "distinctOn": [
                        21,
                        "[AssetsSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        20,
                        "[AssetsOrderBy!]"
                    ],
                    "where": [
                        17
                    ]
                }
            ],
            "companies": [
                33,
                {
                    "distinctOn": [
                        36,
                        "[CompaniesSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        35,
                        "[CompaniesOrderBy!]"
                    ],
                    "where": [
                        34
                    ]
                }
            ],
            "companiesByPk": [
                33,
                {
                    "id": [
                        163,
                        "Int!"
                    ]
                }
            ],
            "companySettings": [
                39,
                {
                    "distinctOn": [
                        46,
                        "[CompanySettingsSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        45,
                        "[CompanySettingsOrderBy!]"
                    ],
                    "where": [
                        42
                    ]
                }
            ],
            "companySettingsByPk": [
                39,
                {
                    "companyId": [
                        163,
                        "Int!"
                    ]
                }
            ],
            "controlPoints": [
                56,
                {
                    "distinctOn": [
                        63,
                        "[ControlPointsSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        62,
                        "[ControlPointsOrderBy!]"
                    ],
                    "where": [
                        59
                    ]
                }
            ],
            "controlPointsByPk": [
                56,
                {
                    "companyId": [
                        163,
                        "Int!"
                    ],
                    "id": [
                        260,
                        "uuid!"
                    ]
                }
            ],
            "customFields": [
                78,
                {
                    "distinctOn": [
                        84,
                        "[CustomFieldsSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        83,
                        "[CustomFieldsOrderBy!]"
                    ],
                    "where": [
                        80
                    ]
                }
            ],
            "energyMeasures": [
                87,
                {
                    "distinctOn": [
                        93,
                        "[EnergyMeasuresSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        92,
                        "[EnergyMeasuresOrderBy!]"
                    ],
                    "where": [
                        89
                    ]
                }
            ],
            "energySources": [
                96,
                {
                    "distinctOn": [
                        102,
                        "[EnergySourcesSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        101,
                        "[EnergySourcesOrderBy!]"
                    ],
                    "where": [
                        98
                    ]
                }
            ],
            "executionActions": [
                105,
                {
                    "distinctOn": [
                        117,
                        "[ExecutionActionsSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        116,
                        "[ExecutionActionsOrderBy!]"
                    ],
                    "where": [
                        109
                    ]
                }
            ],
            "executionActionsByPk": [
                105,
                {
                    "companyId": [
                        163,
                        "Int!"
                    ],
                    "id": [
                        260,
                        "uuid!"
                    ]
                }
            ],
            "executions": [
                128,
                {
                    "distinctOn": [
                        141,
                        "[ExecutionsSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        139,
                        "[ExecutionsOrderBy!]"
                    ],
                    "where": [
                        131
                    ]
                }
            ],
            "executionsByPk": [
                128,
                {
                    "companyId": [
                        163,
                        "Int!"
                    ],
                    "id": [
                        260,
                        "uuid!"
                    ]
                }
            ],
            "hazards": [
                154,
                {
                    "distinctOn": [
                        160,
                        "[HazardsSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        159,
                        "[HazardsOrderBy!]"
                    ],
                    "where": [
                        156
                    ]
                }
            ],
            "isolationDevices": [
                165,
                {
                    "distinctOn": [
                        171,
                        "[IsolationDevicesSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        170,
                        "[IsolationDevicesOrderBy!]"
                    ],
                    "where": [
                        167
                    ]
                }
            ],
            "locations": [
                176,
                {
                    "distinctOn": [
                        182,
                        "[LocationsSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        181,
                        "[LocationsOrderBy!]"
                    ],
                    "where": [
                        178
                    ]
                }
            ],
            "procedureHazards": [
                187,
                {
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        190,
                        "[ProcedureHazardsOrderBy!]"
                    ],
                    "where": [
                        189
                    ]
                }
            ],
            "procedureTypes": [
                191,
                {
                    "distinctOn": [
                        197,
                        "[ProcedureTypesSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        196,
                        "[ProcedureTypesOrderBy!]"
                    ],
                    "where": [
                        193
                    ]
                }
            ],
            "procedures": [
                200,
                {
                    "distinctOn": [
                        207,
                        "[ProceduresSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        206,
                        "[ProceduresOrderBy!]"
                    ],
                    "where": [
                        203
                    ]
                }
            ],
            "proceduresByPk": [
                200,
                {
                    "companyId": [
                        163,
                        "Int!"
                    ],
                    "id": [
                        260,
                        "uuid!"
                    ]
                }
            ],
            "statuses": [
                217,
                {
                    "distinctOn": [
                        223,
                        "[StatusesSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        222,
                        "[StatusesOrderBy!]"
                    ],
                    "where": [
                        219
                    ]
                }
            ],
            "templates": [
                228,
                {
                    "distinctOn": [
                        234,
                        "[TemplatesSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        233,
                        "[TemplatesOrderBy!]"
                    ],
                    "where": [
                        230
                    ]
                }
            ],
            "uploads": [
                238,
                {
                    "distinctOn": [
                        245,
                        "[UploadsSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        244,
                        "[UploadsOrderBy!]"
                    ],
                    "where": [
                        241
                    ]
                }
            ],
            "__typename": [
                226
            ]
        },
        "Mutation": {
            "insertExecutionActions": [
                114,
                {
                    "objects": [
                        111,
                        "[ExecutionActionsInsertInput!]!"
                    ],
                    "onConflict": [
                        115
                    ]
                }
            ],
            "insertExecutionActionsOne": [
                105,
                {
                    "object": [
                        111,
                        "ExecutionActionsInsertInput!"
                    ],
                    "onConflict": [
                        115
                    ]
                }
            ],
            "insertExecutions": [
                136,
                {
                    "objects": [
                        133,
                        "[ExecutionsInsertInput!]!"
                    ],
                    "onConflict": [
                        138
                    ]
                }
            ],
            "insertExecutionsOne": [
                128,
                {
                    "object": [
                        133,
                        "ExecutionsInsertInput!"
                    ],
                    "onConflict": [
                        138
                    ]
                }
            ],
            "updateExecutions": [
                136,
                {
                    "_set": [
                        142
                    ],
                    "where": [
                        131,
                        "ExecutionsBoolExp!"
                    ]
                }
            ],
            "updateExecutionsByPk": [
                128,
                {
                    "_set": [
                        142
                    ],
                    "pkColumns": [
                        140,
                        "ExecutionsPkColumnsInput!"
                    ]
                }
            ],
            "updateExecutionsMany": [
                136,
                {
                    "updates": [
                        150,
                        "[ExecutionsUpdates!]!"
                    ]
                }
            ],
            "__typename": [
                226
            ]
        },
        "Subscription": {
            "assetTypes": [
                0,
                {
                    "distinctOn": [
                        11,
                        "[AssetTypesSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        10,
                        "[AssetTypesOrderBy!]"
                    ],
                    "where": [
                        5
                    ]
                }
            ],
            "assetTypesAggregate": [
                1,
                {
                    "distinctOn": [
                        11,
                        "[AssetTypesSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        10,
                        "[AssetTypesOrderBy!]"
                    ],
                    "where": [
                        5
                    ]
                }
            ],
            "assetTypesStream": [
                0,
                {
                    "batchSize": [
                        163,
                        "Int!"
                    ],
                    "cursor": [
                        12,
                        "[AssetTypesStreamCursorInput]!"
                    ],
                    "where": [
                        5
                    ]
                }
            ],
            "assets": [
                14,
                {
                    "distinctOn": [
                        21,
                        "[AssetsSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        20,
                        "[AssetsOrderBy!]"
                    ],
                    "where": [
                        17
                    ]
                }
            ],
            "assetsStream": [
                14,
                {
                    "batchSize": [
                        163,
                        "Int!"
                    ],
                    "cursor": [
                        25,
                        "[AssetsStreamCursorInput]!"
                    ],
                    "where": [
                        17
                    ]
                }
            ],
            "companies": [
                33,
                {
                    "distinctOn": [
                        36,
                        "[CompaniesSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        35,
                        "[CompaniesOrderBy!]"
                    ],
                    "where": [
                        34
                    ]
                }
            ],
            "companiesByPk": [
                33,
                {
                    "id": [
                        163,
                        "Int!"
                    ]
                }
            ],
            "companiesStream": [
                33,
                {
                    "batchSize": [
                        163,
                        "Int!"
                    ],
                    "cursor": [
                        37,
                        "[CompaniesStreamCursorInput]!"
                    ],
                    "where": [
                        34
                    ]
                }
            ],
            "companySettings": [
                39,
                {
                    "distinctOn": [
                        46,
                        "[CompanySettingsSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        45,
                        "[CompanySettingsOrderBy!]"
                    ],
                    "where": [
                        42
                    ]
                }
            ],
            "companySettingsByPk": [
                39,
                {
                    "companyId": [
                        163,
                        "Int!"
                    ]
                }
            ],
            "companySettingsStream": [
                39,
                {
                    "batchSize": [
                        163,
                        "Int!"
                    ],
                    "cursor": [
                        50,
                        "[CompanySettingsStreamCursorInput]!"
                    ],
                    "where": [
                        42
                    ]
                }
            ],
            "controlPoints": [
                56,
                {
                    "distinctOn": [
                        63,
                        "[ControlPointsSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        62,
                        "[ControlPointsOrderBy!]"
                    ],
                    "where": [
                        59
                    ]
                }
            ],
            "controlPointsByPk": [
                56,
                {
                    "companyId": [
                        163,
                        "Int!"
                    ],
                    "id": [
                        260,
                        "uuid!"
                    ]
                }
            ],
            "controlPointsStream": [
                56,
                {
                    "batchSize": [
                        163,
                        "Int!"
                    ],
                    "cursor": [
                        67,
                        "[ControlPointsStreamCursorInput]!"
                    ],
                    "where": [
                        59
                    ]
                }
            ],
            "customFields": [
                78,
                {
                    "distinctOn": [
                        84,
                        "[CustomFieldsSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        83,
                        "[CustomFieldsOrderBy!]"
                    ],
                    "where": [
                        80
                    ]
                }
            ],
            "customFieldsStream": [
                78,
                {
                    "batchSize": [
                        163,
                        "Int!"
                    ],
                    "cursor": [
                        85,
                        "[CustomFieldsStreamCursorInput]!"
                    ],
                    "where": [
                        80
                    ]
                }
            ],
            "energyMeasures": [
                87,
                {
                    "distinctOn": [
                        93,
                        "[EnergyMeasuresSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        92,
                        "[EnergyMeasuresOrderBy!]"
                    ],
                    "where": [
                        89
                    ]
                }
            ],
            "energyMeasuresStream": [
                87,
                {
                    "batchSize": [
                        163,
                        "Int!"
                    ],
                    "cursor": [
                        94,
                        "[EnergyMeasuresStreamCursorInput]!"
                    ],
                    "where": [
                        89
                    ]
                }
            ],
            "energySources": [
                96,
                {
                    "distinctOn": [
                        102,
                        "[EnergySourcesSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        101,
                        "[EnergySourcesOrderBy!]"
                    ],
                    "where": [
                        98
                    ]
                }
            ],
            "energySourcesStream": [
                96,
                {
                    "batchSize": [
                        163,
                        "Int!"
                    ],
                    "cursor": [
                        103,
                        "[EnergySourcesStreamCursorInput]!"
                    ],
                    "where": [
                        98
                    ]
                }
            ],
            "executionActions": [
                105,
                {
                    "distinctOn": [
                        117,
                        "[ExecutionActionsSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        116,
                        "[ExecutionActionsOrderBy!]"
                    ],
                    "where": [
                        109
                    ]
                }
            ],
            "executionActionsByPk": [
                105,
                {
                    "companyId": [
                        163,
                        "Int!"
                    ],
                    "id": [
                        260,
                        "uuid!"
                    ]
                }
            ],
            "executionActionsStream": [
                105,
                {
                    "batchSize": [
                        163,
                        "Int!"
                    ],
                    "cursor": [
                        121,
                        "[ExecutionActionsStreamCursorInput]!"
                    ],
                    "where": [
                        109
                    ]
                }
            ],
            "executions": [
                128,
                {
                    "distinctOn": [
                        141,
                        "[ExecutionsSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        139,
                        "[ExecutionsOrderBy!]"
                    ],
                    "where": [
                        131
                    ]
                }
            ],
            "executionsByPk": [
                128,
                {
                    "companyId": [
                        163,
                        "Int!"
                    ],
                    "id": [
                        260,
                        "uuid!"
                    ]
                }
            ],
            "executionsStream": [
                128,
                {
                    "batchSize": [
                        163,
                        "Int!"
                    ],
                    "cursor": [
                        146,
                        "[ExecutionsStreamCursorInput]!"
                    ],
                    "where": [
                        131
                    ]
                }
            ],
            "hazards": [
                154,
                {
                    "distinctOn": [
                        160,
                        "[HazardsSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        159,
                        "[HazardsOrderBy!]"
                    ],
                    "where": [
                        156
                    ]
                }
            ],
            "hazardsStream": [
                154,
                {
                    "batchSize": [
                        163,
                        "Int!"
                    ],
                    "cursor": [
                        161,
                        "[HazardsStreamCursorInput]!"
                    ],
                    "where": [
                        156
                    ]
                }
            ],
            "isolationDevices": [
                165,
                {
                    "distinctOn": [
                        171,
                        "[IsolationDevicesSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        170,
                        "[IsolationDevicesOrderBy!]"
                    ],
                    "where": [
                        167
                    ]
                }
            ],
            "isolationDevicesStream": [
                165,
                {
                    "batchSize": [
                        163,
                        "Int!"
                    ],
                    "cursor": [
                        172,
                        "[IsolationDevicesStreamCursorInput]!"
                    ],
                    "where": [
                        167
                    ]
                }
            ],
            "locations": [
                176,
                {
                    "distinctOn": [
                        182,
                        "[LocationsSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        181,
                        "[LocationsOrderBy!]"
                    ],
                    "where": [
                        178
                    ]
                }
            ],
            "locationsStream": [
                176,
                {
                    "batchSize": [
                        163,
                        "Int!"
                    ],
                    "cursor": [
                        183,
                        "[LocationsStreamCursorInput]!"
                    ],
                    "where": [
                        178
                    ]
                }
            ],
            "procedureHazards": [
                187,
                {
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        190,
                        "[ProcedureHazardsOrderBy!]"
                    ],
                    "where": [
                        189
                    ]
                }
            ],
            "procedureTypes": [
                191,
                {
                    "distinctOn": [
                        197,
                        "[ProcedureTypesSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        196,
                        "[ProcedureTypesOrderBy!]"
                    ],
                    "where": [
                        193
                    ]
                }
            ],
            "procedureTypesStream": [
                191,
                {
                    "batchSize": [
                        163,
                        "Int!"
                    ],
                    "cursor": [
                        198,
                        "[ProcedureTypesStreamCursorInput]!"
                    ],
                    "where": [
                        193
                    ]
                }
            ],
            "procedures": [
                200,
                {
                    "distinctOn": [
                        207,
                        "[ProceduresSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        206,
                        "[ProceduresOrderBy!]"
                    ],
                    "where": [
                        203
                    ]
                }
            ],
            "proceduresByPk": [
                200,
                {
                    "companyId": [
                        163,
                        "Int!"
                    ],
                    "id": [
                        260,
                        "uuid!"
                    ]
                }
            ],
            "proceduresStream": [
                200,
                {
                    "batchSize": [
                        163,
                        "Int!"
                    ],
                    "cursor": [
                        211,
                        "[ProceduresStreamCursorInput]!"
                    ],
                    "where": [
                        203
                    ]
                }
            ],
            "statuses": [
                217,
                {
                    "distinctOn": [
                        223,
                        "[StatusesSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        222,
                        "[StatusesOrderBy!]"
                    ],
                    "where": [
                        219
                    ]
                }
            ],
            "statusesStream": [
                217,
                {
                    "batchSize": [
                        163,
                        "Int!"
                    ],
                    "cursor": [
                        224,
                        "[StatusesStreamCursorInput]!"
                    ],
                    "where": [
                        219
                    ]
                }
            ],
            "templates": [
                228,
                {
                    "distinctOn": [
                        234,
                        "[TemplatesSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        233,
                        "[TemplatesOrderBy!]"
                    ],
                    "where": [
                        230
                    ]
                }
            ],
            "templatesStream": [
                228,
                {
                    "batchSize": [
                        163,
                        "Int!"
                    ],
                    "cursor": [
                        235,
                        "[TemplatesStreamCursorInput]!"
                    ],
                    "where": [
                        230
                    ]
                }
            ],
            "uploads": [
                238,
                {
                    "distinctOn": [
                        245,
                        "[UploadsSelectColumn!]"
                    ],
                    "limit": [
                        163
                    ],
                    "offset": [
                        163
                    ],
                    "orderBy": [
                        244,
                        "[UploadsOrderBy!]"
                    ],
                    "where": [
                        241
                    ]
                }
            ],
            "uploadsStream": [
                238,
                {
                    "batchSize": [
                        163,
                        "Int!"
                    ],
                    "cursor": [
                        249,
                        "[UploadsStreamCursorInput]!"
                    ],
                    "where": [
                        241
                    ]
                }
            ],
            "__typename": [
                226
            ]
        }
    }
};
